import React, { useContext } from "react";
import { useRouteMatch } from "react-router";
import useSWR from "swr";
import { Header } from "../../components/Header/Header";
import { NotesArea } from "../../components/NotesArea/NotesArea";
import { Sidebar } from "../../components/Sidebar/Sidebar";
import { BackendContext } from "../../services/backend-context";
import { Note } from "../../types/types";
import styles from "./NotesView.module.css"

export function NotesView() {
    const route = useRouteMatch<{ userId: string }>();
    const backendConfig = useContext(BackendContext);

    const { data, error, isValidating, revalidate } = useSWR(`${backendConfig.backend}/users/${route.params.userId}/notes`, key => (
        fetch(key).then(resp => resp.json())
    ), { revalidateOnFocus: false, refreshInterval: 1000000 });

    const onDeleteNote = (note: Note) => {
        fetch(`${backendConfig.backend}/users/${route.params.userId}/notes/${note.noteId}`,
            { method: "DELETE" }
        ).then(resp => resp.json())
         .then(() => {
             revalidate();
         })
    }
    
    return (
        <div className={ styles.container }>
            <Header />
                { !data
                    ? <div>Loading</div>
                    : <NotesArea notes={ data } error={ error } loading={ isValidating } onNoteSaved={ revalidate } />
                }
            <Sidebar notes={ data } onDeleteNote={ onDeleteNote } />
        </div>
    )
}